import type { SettingsCategoryKey } from '@/config/settingsRegistry';

export type SettingsCategoryTheme = {
  headerBg: string;
  headerText: string;
  iconBg: string;
  iconText: string;
  itemHover: string;
  itemActive: string;
  itemActiveText: string;
  itemActiveIcon: string;
};

export const SETTINGS_CATEGORY_THEMES: Record<SettingsCategoryKey, SettingsCategoryTheme> = {
  organization: {
    headerBg: 'bg-emerald-50 dark:bg-emerald-950/40',
    headerText: 'text-emerald-900 dark:text-emerald-100',
    iconBg: 'bg-emerald-100 dark:bg-emerald-900/60',
    iconText: 'text-emerald-700 dark:text-emerald-300',
    itemHover: 'hover:bg-emerald-50/80 dark:hover:bg-emerald-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  'hr-master-data': {
    headerBg: 'bg-violet-50 dark:bg-violet-950/40',
    headerText: 'text-violet-900 dark:text-violet-100',
    iconBg: 'bg-violet-100 dark:bg-violet-900/60',
    iconText: 'text-violet-700 dark:text-violet-300',
    itemHover: 'hover:bg-violet-50/80 dark:hover:bg-violet-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  hr: {
    headerBg: 'bg-violet-50 dark:bg-violet-950/40',
    headerText: 'text-violet-900 dark:text-violet-100',
    iconBg: 'bg-violet-100 dark:bg-violet-900/60',
    iconText: 'text-violet-700 dark:text-violet-300',
    itemHover: 'hover:bg-violet-50/80 dark:hover:bg-violet-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  finance: {
    headerBg: 'bg-teal-50 dark:bg-teal-950/40',
    headerText: 'text-teal-900 dark:text-teal-100',
    iconBg: 'bg-teal-100 dark:bg-teal-900/60',
    iconText: 'text-teal-700 dark:text-teal-300',
    itemHover: 'hover:bg-teal-50/80 dark:hover:bg-teal-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  inventory: {
    headerBg: 'bg-rose-50 dark:bg-rose-950/40',
    headerText: 'text-rose-900 dark:text-rose-100',
    iconBg: 'bg-rose-100 dark:bg-rose-900/60',
    iconText: 'text-rose-700 dark:text-rose-300',
    itemHover: 'hover:bg-rose-50/80 dark:hover:bg-rose-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  crm: {
    headerBg: 'bg-sky-50 dark:bg-sky-950/40',
    headerText: 'text-sky-900 dark:text-sky-100',
    iconBg: 'bg-sky-100 dark:bg-sky-900/60',
    iconText: 'text-sky-700 dark:text-sky-300',
    itemHover: 'hover:bg-sky-50/80 dark:hover:bg-sky-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  marketing: {
    headerBg: 'bg-pink-50 dark:bg-pink-950/40',
    headerText: 'text-pink-900 dark:text-pink-100',
    iconBg: 'bg-pink-100 dark:bg-pink-900/60',
    iconText: 'text-pink-700 dark:text-pink-300',
    itemHover: 'hover:bg-pink-50/80 dark:hover:bg-pink-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  projects: {
    headerBg: 'bg-indigo-50 dark:bg-indigo-950/40',
    headerText: 'text-indigo-900 dark:text-indigo-100',
    iconBg: 'bg-indigo-100 dark:bg-indigo-900/60',
    iconText: 'text-indigo-700 dark:text-indigo-300',
    itemHover: 'hover:bg-indigo-50/80 dark:hover:bg-indigo-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  'help-desk': {
    headerBg: 'bg-cyan-50 dark:bg-cyan-950/40',
    headerText: 'text-cyan-900 dark:text-cyan-100',
    iconBg: 'bg-cyan-100 dark:bg-cyan-900/60',
    iconText: 'text-cyan-700 dark:text-cyan-300',
    itemHover: 'hover:bg-cyan-50/80 dark:hover:bg-cyan-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  communication: {
    headerBg: 'bg-orange-50 dark:bg-orange-950/40',
    headerText: 'text-orange-900 dark:text-orange-100',
    iconBg: 'bg-orange-100 dark:bg-orange-900/60',
    iconText: 'text-orange-700 dark:text-orange-300',
    itemHover: 'hover:bg-orange-50/80 dark:hover:bg-orange-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  workflow: {
    headerBg: 'bg-amber-50 dark:bg-amber-950/40',
    headerText: 'text-amber-900 dark:text-amber-100',
    iconBg: 'bg-amber-100 dark:bg-amber-900/60',
    iconText: 'text-amber-700 dark:text-amber-300',
    itemHover: 'hover:bg-amber-50/80 dark:hover:bg-amber-950/30',
    itemActive: 'bg-amber-100 dark:bg-amber-900/50',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  approvals: {
    headerBg: 'bg-yellow-50 dark:bg-yellow-950/40',
    headerText: 'text-yellow-900 dark:text-yellow-100',
    iconBg: 'bg-yellow-100 dark:bg-yellow-900/60',
    iconText: 'text-yellow-700 dark:text-yellow-300',
    itemHover: 'hover:bg-yellow-50/80 dark:hover:bg-yellow-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  notifications: {
    headerBg: 'bg-fuchsia-50 dark:bg-fuchsia-950/40',
    headerText: 'text-fuchsia-900 dark:text-fuchsia-100',
    iconBg: 'bg-fuchsia-100 dark:bg-fuchsia-900/60',
    iconText: 'text-fuchsia-700 dark:text-fuchsia-300',
    itemHover: 'hover:bg-fuchsia-50/80 dark:hover:bg-fuchsia-950/30',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
  developer: {
    headerBg: 'bg-zinc-100 dark:bg-zinc-800/60',
    headerText: 'text-zinc-900 dark:text-zinc-100',
    iconBg: 'bg-zinc-200 dark:bg-zinc-700',
    iconText: 'text-zinc-600 dark:text-zinc-300',
    itemHover: 'hover:bg-zinc-50 dark:hover:bg-zinc-800/60',
    itemActive: 'bg-amber-50 dark:bg-amber-950/40',
    itemActiveText: 'text-amber-900 dark:text-amber-100',
    itemActiveIcon: 'text-amber-600 dark:text-amber-400',
  },
};

export function getSettingsCategoryTheme(key: SettingsCategoryKey): SettingsCategoryTheme {
  return SETTINGS_CATEGORY_THEMES[key];
}
